export const API_CONSTANTS = {
  FILES: '/files',
  FILES_COUNT: '/files/count',
  FIRMWARE_IMAGES: '/firmware-images',
  FIRMWARE_IMAGES_COUNT: '/firmware-images/count',
  FIRMWARE_IMAGES_UPLOAD: '/firmware-images/upload',
  JOBS: '/jobs',
  JOB_DEFINITIONS: '/job-definitions',
  LOGIN: '/users/login',
  LOGOUT: '/users/logout',
  TAGS: '/tags',
  TASKS: '/tasks',
  USERS: '/users',
  INVITE_USER: '/users/action'
};

export const CVE_DETAILS_URL = 'https://nvd.nist.gov/vuln/detail/';
export const LAST_ORG_USED_KEY = '|lastOrgUsedId';

// Keyed on `sub`, never on `email`.  The ID token carries no `email` claim when
// the Auth0 profile has none, and `undefined + KEY` is one slot shared by every
// user of the browser - so one identity's last org was handed to another's
// login, where it fails an org-scoped token exchange.  `sub` is always present.
export const lastOrgUsedKeyFor = idToken => `${idToken?.sub ?? ''}${LAST_ORG_USED_KEY}`;
